import ArtworkCard from "../ArtworkCard/ArtworkCard";
import { useImagine } from "@/context/ImagineContext";
import { Fragment, useEffect } from "react";
import styles from "./ImageGallery.module.scss";
import { ArtWork } from "@/models/models";

interface ImageGalleryProps {
  onClick: (artWork: ArtWork) => void;
  ArtWorks: ArtWork[];
}

const ImageGallery = (props: ImageGalleryProps) => {
  const { isLoading, resultImages } = useImagine();
  useEffect(() => {}, [resultImages]);

  return (
    <Fragment>
      {props.ArtWorks?.length > 0 ? (
        <div className={styles.galleryContainer}>
          {props.ArtWorks.map((result: ArtWork, indexParent: number) => (
            <div className={styles.promptResults} key={indexParent}>
              <div className={styles.galleryRow}>
                <p className="body-2 mb-4 center">{result.prompt?.prompt}</p>
                <ArtworkCard
                  artwork={{
                    image: result.preview || result.image || "",
                    prompt: result.prompt,
                  }}
                  isModalEnabled={false}
                  onClick={() => {
                    props.onClick(result);
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.galleryContainer}>
          <div className={styles.promptResults}>
            <div className={styles.galleryRow}>
              <div className="h-3 w-2/3 rounded bg-[#252238] mb-4 " />
              {resultImages[0]?.images[0] ? (
                <img
                  src={resultImages[0].images[0]}
                  alt="generated skin"
                  className="w-full aspect-square rounded-xl object-cover"
                />
              ) : (
                <div className="w-full aspect-square rounded-xl bg-[#252238]" />
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default ImageGallery;
